/* eslint-disable react/no-array-index-key */
import { Input, Spinner, Tab, Tabs } from '@nextui-org/react';
import React from 'react';

import RegisterParceiro from '../../components/RegisterParceiro/RegisterParceiro';
import useParceiros from './hooks/useParceiros';
import ParceirosTable from './ParceirosTable/ParceirosTable';

const Parceiros = (): JSX.Element => {
  const {
    activeTab,
    setActiveTab,
    handleGetParceiros,
    loading,
    parceiros,
    modalRef,
    setFilter,
    filter,
  } = useParceiros();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-end justify-between">
        <p className="text-default-500">
          Selecione um parceiro para ver seus detalhes ou editá-lo:
        </p>

        <div className="grid grid-cols-2 items-end gap-8 ">
          <Input
            size="md"
            type="text"
            label="Filtro"
            variant="underlined"
            placeholder="Sigla ou CEP"
            autoFocus
            classNames={{
              label: 'font-bold',
            }}
            onValueChange={(value) => setFilter(value)}
          />

          <RegisterParceiro
            useModalStyle
            onUpdate={handleGetParceiros}
            ref={modalRef}
            tipo={activeTab}
          />
        </div>
      </div>

      <Tabs
        aria-label="Tipos de parceiro"
        selectedKey={activeTab}
        onSelectionChange={(key) => setActiveTab(key as 'entrega' | 'coleta')}
      >
        <Tab key="entrega" title="Entrega" />
        <Tab key="coleta" title="Coleta" />
      </Tabs>

      {loading && <Spinner label="Baixando conteúdo" color="default" />}

      {!loading && (
        <ParceirosTable
          filter={filter}
          parceiros={parceiros}
          onRowClick={(parceiro) => modalRef.current?.openToEdit(parceiro)}
        />
      )}
    </div>
  );
};

export default Parceiros;
